import { AppSettingsService } from "../../services/appsettings.service";
import { AuthenticationService } from "../../services/authentication.service";
import { TiersService } from "../../services/tiers.service";
import { cls_profilContact } from "../../shared/components/pageProfilContact/pageProfilContact.component";
import { cls_profilEntreprise } from "../../shared/components/pageProfilEntreprise/pageProfilEntreprise.component";
import { cls_register_mdp } from "./register_mdp.component";
import { Component, ViewChild, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { varGlobal } from "../../shared/varGlobal";

@Component({
  selector: "app-register",
  styleUrls: ["./register.component.scss"],
  templateUrl: "./register.component.html"
})
export class cls_register implements OnInit {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "registerPage.";
  /** Session en cours */
  public h_currentUser: any;
  /** Loading sur création des frames */
  public f_loadingFrame = true;
  /** Loading sur chargement */
  public f_loadingCharge = true;
  /** Loading sur validation de l'inscription */
  public f_loadingEnvoi = false;

  /** Donnée courante sur le profil */
  public h_tiersProfil: any;

  /** Paramètre Id chef de grappe (dans le cas d'un register via lien CDG) */
  public w_tiersIdMd5: string;
  /** Infos sur le CDG */
  public h_cdg: any;

  @ViewChild(cls_profilEntreprise) frame_entr: cls_profilEntreprise;
  @ViewChild(cls_profilContact) frame_contact: cls_profilContact;
  @ViewChild(cls_register_mdp) frame_mdp: cls_register_mdp;

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public s_appsettings: AppSettingsService,
    public route: ActivatedRoute,
    public router: Router,
    public s_authentication: AuthenticationService,
    public s_translate: TranslateService,
    public s_tiers: TiersService,
    public s_global: varGlobal
  ) {
    //Dans le cas ou on charge l'application par cette page et non par le login, on charge la langue par défaut du navigateur
    if (!this.s_translate.currentLang) {
      //Initialisation de la langue a afficher
      this.s_appsettings.proc_initLangue();
    }

    //Recuperation du parametre tiersId pour l'ajout de chef de grappe
    this.route.params.subscribe(params => {
      this.w_tiersIdMd5 = params["tiersId"];
    });
  }

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Initialisation
   */
  public ngOnInit(): void {
    // Exécute les boucles de chargement
    this.proc_boucle_frame();
    this.proc_boucle();
  }

  /**
   * Chargement des données de la base
   * mis dans une fonction avec timeout pour le cas de rechargement de page
   * où le appSettings est chargé en retard (Pb de pathAPI pas initialisé)
   */
  public proc_boucle = function() {
    if (this.s_global.pathAPI === "pathAPI") {
      setTimeout(() => {
        this.proc_boucle();
      }, 1000);
      return;
    }

    // Test du ID CDG
    if (this.w_tiersIdMd5 != null) {
      this.s_tiers.proc_getTiersbyMd5id(this.w_tiersIdMd5).subscribe(
        data => {
          this.h_cdg = data;
          this.f_loadingCharge = false;
        },
        error => {
          this.s_appsettings.proc_gestionErreur(error);
          this.f_loadingCharge = false;
        }
      );
    } else this.f_loadingCharge = false;
  };

  /**
   * Test du formulaire et sauvegarde de l'inscription
   */
  public proc_register() {
    // Infos sur l'entreprise
    const h_form: any = this.frame_entr.proc_getData();
    if (h_form == null) return;

    // Infos sur le contact
    let h_data = this.frame_contact.proc_getData();
    if (h_data == null) return;
    for (const key of Object.keys(h_data)) {
      h_form[key] = h_data[key];
    }

    // Infos sur le MDP
    h_data = this.frame_mdp.proc_getData();
    if (h_data == null) return;
    for (const key of Object.keys(h_data)) {
      h_form[key] = h_data[key];
    }
    const w_user = this.frame_mdp.proc_getUser();
    const w_pass = this.frame_mdp.proc_getMDP();

    h_form["isadmin"] = false;
    h_form["chefgrappe"] = false;
    h_form["actiftiers"] = true;
    h_form["obscgvtiers"] = "";

    this.f_loadingEnvoi = true;
    this.h_tiersProfil = h_form;
    //Creation du compte + connexion a l'application
    this.s_tiers.proc_register(h_form).subscribe(
      data => {
        //Connexion a l'application
        this.proc_login(w_user, w_pass);
      },
      error => {
        this.s_appsettings.proc_gestionErreur(error);
        this.proc_majAffichage();
      }
    );
  }

  /**
   * Annulation de l'inscription
   */
  public proc_boutonAnnuler() {
    this.router.navigate(["auth/login"]);
  }

  /**
   * Login si la creation de compte est un succes
   */
  public proc_login(w_user: string, w_pass: string) {
    this.s_authentication
      .proc_login(w_user, w_pass, this.w_tiersIdMd5)
      .subscribe(
        data => {
          this.h_currentUser = JSON.parse(localStorage.getItem("currentUser"));
          if (this.h_currentUser.CGVValid === "false")
            this.router.navigate(["pages/commun/pageCGV"]);
          else this.router.navigate(["pages/commun/pageAccueil"]);
        },
        error => {
          this.s_appsettings.proc_gestionErreur(error);
          this.f_loadingEnvoi = false;
        }
      );
  }

  /**
   * Màj du flag de la case à cocher
   */
  public proc_majAffichage() {
    if (this.f_loadingEnvoi) {
      this.f_loadingEnvoi = false;
      this.f_loadingFrame = true;
      //Appel d'une boucle jusqu'à la création des frames
      //Qui rapellera ensuite cette même procédure pour la màj de l'affichage
      this.proc_boucle_frame();
    } else {
      if (this.frame_entr != null)
        this.frame_entr.proc_setData(this.h_tiersProfil, false);
      if (this.frame_contact != null)
        this.frame_contact.proc_setData(false, this.h_tiersProfil, false);
      this.f_loadingFrame = false;
    }
  }

  /**
   * Création des frames liées
   */
  public proc_boucle_frame = function() {
    if (this.frame_entr == null || this.frame_contact == null) {
      setTimeout(() => {
        this.proc_boucle_frame();
      }, 100);
      return;
    }

    this.proc_majAffichage();
  };
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/register/register.component.ts